import { setAnalytics } from '../../../thd-analytics-utils';

export function dashboard() {
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('dashboard.page-load', () => {
    digitalData.page = {
      category: {
        primaryCategory: 'account dashboard',
        subCategory1: 'account dashboard',
        subCategory2: 'account dashboard'
      },
      pageInfo: {
        pageName: 'account dashboard',
        pageType: 'maml:account dashboard'
      }
    };

    setAnalytics(digitalData);
  });
}